export default __webpack_public_path__ + "7b2fc4a39ce119c70e885ba87832b6b4.png";